import { atom } from "jotai";
import type { IJWTUserPayload } from "../../../../interfaces/JWTUserPayload";
import { getDecodedUserAccessTokenFromBrowserCookies } from "./get-decoded-user-access-token-from-browser-cookies/get-decoded-user-access-token-from-browser-cookies";

export const accessTokenAtom = atom<IJWTUserPayload | undefined>(getDecodedUserAccessTokenFromBrowserCookies());
